import React, { useCallback } from 'react';
import { useField } from 'formik';
import clsx from 'clsx';
import { IFormItem } from '../form-item.type';
import { FormErrorMsg } from '../form-error-msg';

interface ITextarea extends IFormItem {
  placeholder?: string;

  className?: string;
}

export function Textarea({ name, disabled = false, placeholder = '', className = '', onChange }: ITextarea) {
  const [field] = useField(name);

  const handleChange = useCallback(
    (e) => {
      field.onChange(e);
      onChange && onChange(e);
    },
    [field, onChange]
  );

  return (
    <>
      <textarea
        name={name}
        disabled={disabled}
        placeholder={placeholder}
        onChange={handleChange}
        onBlur={field.onBlur}
        className={clsx('form-control', className)}
        value={field.value}
      />

      <FormErrorMsg name={name} />
    </>
  );
}
